import axios from 'axios'
import fn from '../../utils/functions'

function initSession () {
  const session = {}
  return session
}
// state
const state = {
  session: initSession()
}

// getters
const getters = {}

// actions
const actions = {
  isNewVersionEstadisticaLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.estadistica)
  },
  /* SERVICIOS
  * Servicio para traer los resultados de la estadistica.
  */
  async getStatisticInvoice ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/statistic/invoices',
        data: data
      })

      console.log('RESPONSE getServices:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getDataInvoiceSellerAmount ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/statistic/seller/amount',
        data: data
      })
      console.log('RESPONSE getServices:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getStatisticParty ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/statistic/parties',
        data: data
      })
      console.log('RESPONSE getStatisticParty:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getStatisticDigitalization ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/statistic/rejected',
        data: data
      })

      console.log('RESPONSE getServices:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  }
}
// mutations
const mutations = {
  resetSessionEstadistica (state) {
    state.session = initSession()
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
